import 'jquery';
import './changeElementType.js';
import { hasSupport } from './browser';
import { getFullheightOffset } from './viewport';

export default class WpBackeryBS4 {
  constructor() {
    this.menuToNav();
    this.menuBoundaries();
    this.setSingleBackgroundImages();
    this.fixFooterNavs();
    this.dropdownOnHover();
    this.initCollapse();
    this.setActiveAccordionItem();
    this.setActiveCarouselItem();
    this.setActiveTablistItem();
    this.fixes();
    this.fixHoverUnderStretchedLinks();
  }

  fixes() {
    $('.wpb_wrapper > *').unwrap('.wpb_wrapper');
    $('.vc_column-inner')
      .removeClass('vc_column-inner')
      .addClass('column-inner');
    $('.wpb_column')
      .removeClass('wpb_column')
      .addClass('column');

    $('.wpml-ls-link', '.wpml-ls-current-language').addClass('active');
  }

  fixHoverUnderStretchedLinks() {
    const $main = $('.main');
    $('[data-hover]', $main).each((i, el) => {
      const $el = $(el);
      const $stretchedLink = $el.siblings('.stretched-link');
      if (!$stretchedLink.length) {
        return;
      }
      $stretchedLink
        .on('mouseenter', () => {
          $el.addClass('hover');
        })
        .on('mouseleave', () => {
          $el.removeClass('hover');
        });
    });
  }

  initCollapse() {
    $('.collapse', '.accordion').on('shown.bs.collapse', e => {
      const element = $(e.currentTarget);
      let offset = getFullheightOffset() || 0;
      let top = element.offset().top;
      if (element.parent('.card')) {
        top = element.parent().offset().top;
      }
      window.console.log(element, top, offset);
      $('html, body')
        .stop()
        .animate({ scrollTop: top - offset }, 500);
    });
    if (window.location.hash) {
      setTimeout(() => {
        $(window.location.hash)
          .filter('.collapse')
          .collapse('show');
      }, 500);
    }
  }

  setActiveAccordionItem() {
    $('.accordion').each((i, accordion) => {
      const items = $('.collapse', accordion);
      if (!items.filter('.show').length) {
        items.first().addClass('show');
      }
    });
  }

  setActiveCarouselItem() {
    $('.carousel').each((i, carousel) => {
      const items = $('.carousel-item', carousel);
      if (!items.filter('.active').length) {
        items.first().addClass('active');
      }
    });
  }

  setActiveTablistItem() {
    const currentRoute = window.location.href.replace(window.location.hash, '').replace(window.location.protocol, '');
    let scroll = true;

    $('.tablist, .tab-content').each((i, tablist) => {
      const items = $('.tab-pane', tablist);
      items.each((i, tab) => {
        let navLink = $(`a[href='${currentRoute}#${tab.id}']`);
        if (!navLink.length) {
          navLink = $(`a[href='${window.location.pathname}#${tab.id}']`);
        }
        if (navLink.length) {
          const $tab = $(tab);
          const tabLink = $tab.attr('aria-labelledby');
          navLink
            .attr({
              'data-toggle': 'tab',
              'aria-controls': tab.id,
              'aria-selected': $tab.is('.active'),
            })
            .on('click.tab', event => {
              event.preventDefault();
              $(`#${tabLink}`).tab('show');
            });
        }
      });

      if (!items.filter('.active').length || (window.location.hash && $(window.location.hash).length)) {
        let hash = window.location.hash;
        let tab = hash && $(hash);
        if (!tab.length) {
          tab = items.first();
          scroll = false;
        }
        let tabLink = tab.attr('aria-labelledby');

        if (tabLink) {
          const $tabLink = $(`#${tabLink}`);
          if (tab.is('.active')) {
            tab.removeClass('active');
            $tabLink.removeClass('active');
          }
          setTimeout(() => $tabLink.tab('show'), 700);
        }
      }
    });

    $('[data-toggle="tab"]').on('shown.bs.tab', e => {
      if (!scroll) {
        return;
      }
      const element = $(e.currentTarget);
      let offset = getFullheightOffset() || 0;
      let top = element.offset().top;
      if (element.parent('.tab-content')) {
        top = element.closest('.tablist').offset().top;
      }
        window.console.log(element, top);
      $('html, body')
        .stop()
        .animate({ scrollTop: top - offset }, 500);
    });
  }

  setSingleBackgroundImages() {
    // $('.wpb_single_image')
    //   .filter(':only-child')
    //   .each((index, image) => {
    //     const $image = $('img', image);
    //     const $columm = $image.closest('.col, [class*="col-"]');
    //     $columm.addClass('has-bg-image').css({
    //       'background-image': `url("${$image.attr('src')}}")`,
    //     });
    //     $image.remove();
    //   });
  }

  menuBoundaries() {
    const $navs = $('.nav, .navbar-nav');

    $navs.each(function() {
      const $nav = $(this);
      const $container = $nav.closest('.navbar') || $nav;
      const $links = $('> .nav-item > .nav-link, > a', $nav);
      const linkLabels = $links
        .map(function() {
          return $.trim($(this).text());
        })
        .get();
      const maxChars = Math.max(...linkLabels.map(el => el.length));
      $container.attr({
        'data-nav-items': linkLabels.length,
        'data-nav-length': linkLabels.join('').length,
        'data-nav-max-chars': maxChars,
      });
      const $header = $nav.closest('.banner');
      if ($header.length && 'logo-separator' === $header.data('layout')) {
        const center = Math.ceil(parseFloat(linkLabels.join('').length / 2, 10));
        for (let i = 0, l = 0; i < linkLabels.length; i++) {
          l += linkLabels[i].length;
          if (l > center) {
            $('<ul />')
              .addClass($nav.attr('class'))
              .append($nav.children().slice(i + 1))
              .insertAfter($nav);
            break;
          }
        }
      }
    });

    $('[data-nav-max-chars]', '.main').each(function() {
      let $nav = $(this);
      let maxChars = $nav.data('nav-max-chars');
      if (maxChars) {
        let padding = $nav.data('nav-items') * 3 + 'rem';
        $nav.css('min-width', 'calc(' + $nav.data('nav-items') * maxChars + 'ch + ' + padding + ')');
      }
    });
  }

  menuToNav() {
    const $menues = $('.widget_nav_menu');
    $('.menu', $menues)
      .addClass('navbar-nav')
      .removeClass('menu');
    $('.menu-item', $menues)
      .addClass('nav-item')
      .removeClass('menu-item');
    $('.menu-link', $menues)
      .addClass('nav-link')
      .removeClass('menu-link');
    $menues
      .addClass('navbar navbar-expand')
      .closest('.container')
      .find('.copyright')
      .addClass('navbar-text');
  }

  fixFooterNavs() {
    const $footerNavs = $('.navbar-expand', '.footer');
    $footerNavs.addClass('d-none d-lg-flex');
    const $mainNav = $('#navbar-main');
    if ($mainNav.length && 2 > $('ul', $mainNav).length) {
      let $links = $('.navbar-nav > *', $footerNavs);
      if ($links.length) {
        $links
          .clone()
          .addClass('d-lg-none')
          .appendTo($('.navbar-nav', $mainNav));
      }
    }
  }

  dropdownOnHover(selector = '.dropdown', wait = 300) {
    if (hasSupport('touch')) {
      return;
    }
    $('body').on('mouseenter mouseleave', selector, function(event) {
      const _d = $(event.target).closest(selector);
      _d.addClass('show');
      setTimeout(() => {
        _d[_d.is(':hover') ? 'addClass' : 'removeClass']('show');
        _d.is(':hover') && _d.siblings(selector).removeClass('show');
      }, wait);
    });
  }
}



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/WpBackeryBS4.js